export { default } from 'grapheme-splitter';